import { useState } from "react"
import { IconFileSpreadsheet } from "@tabler/icons-react"
import { Button } from "@/components/ui/button"
import { api } from "@/lib/api"
import { hasPermission } from "@/store/permissionsSlice"

/** The quarterly access-review download (AB#741). The API enforces `admin:view-access` on its own. */
export const ACCESS_REVIEW_PATH = "/api/admin/users/access-review"

/** Whether to show the export: the same permission the endpoint requires. */
export function canExportAccessReview(permissions: string[]): boolean {
  return hasPermission(permissions, "admin:view-access")
}

export function ExportAccessReviewButton() {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const exportReview = async () => {
    if (busy) return
    setBusy(true)
    setError(null)
    try {
      await api.download(ACCESS_REVIEW_PATH, "access-review.csv", "text/csv")
    } catch (failure) {
      const status = failure instanceof Error && "status" in failure ? failure.status : null
      setError(status === 403
        ? "Your account cannot export the access review."
        : "The access review could not be downloaded. Please try again or contact support.")
    } finally {
      setBusy(false)
    }
  }

  return <div className="flex flex-col items-end gap-1">
    <Button type="button" variant="outline" disabled={busy} onClick={() => void exportReview()}>
      <IconFileSpreadsheet className="size-4" />{busy ? "Preparing access review…" : "Export access review"}
    </Button>
    {error && <p className="text-sm text-destructive" role="alert">{error}</p>}
  </div>
}
